import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './FoldersListItem.css';

interface IProps {
  onClick(): void;
}

export function FoldersListItemNew({ onClick }: IProps) {
  return (
    <div {...mergeStyles(styles['container'], styles['container-new-item'])} onClick={onClick}>
      <div className={styles['image']}>
        <IconActionPlus16 color="icon-main-default" />
      </div>
      <div className={styles['title']}>Новая подборка</div>
    </div>
  );
}
